/*
  cart-recs-scroll-progress.js — continuous progress line for the cart's native
  scroll recommendation row (upsell block, stacking = scroll).

  The lit segment's width mirrors the visible fraction of the row and its offset
  mirrors scrollLeft, so the line glides with the finger like ekster's, no dots,
  no page steps. Wired as ONE capture-phase listener on document: scroll events
  do not bubble, but capture still descends to them, and a delegated listener
  survives every cart section re-render (inline scripts and per-element wiring
  would die with the swapped DOM).
*/
(function () {
  'use strict';

  function sync(row) {
    var bar = row.parentElement.querySelector('[data-upsell-scroll-bar]');
    /* clientWidth 0 = layout not computed yet (background tab, mid-render):
       writing 0% would blank the bar, so keep the CSS fallback width instead */
    if (!bar || row.scrollWidth <= 0 || row.clientWidth <= 0) return;
    var visible = (row.clientWidth / row.scrollWidth) * 100;
    var offset = (row.scrollLeft / row.scrollWidth) * 100;
    bar.style.width = visible + '%';
    bar.style.marginLeft = offset + '%';
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var row = event.target instanceof Element && event.target.closest('[data-upsell-scroll]');
      if (row) sync(row);
    },
    true
  );

  /* first paint: size the segment to the real visible fraction */
  function initAll() {
    document.querySelectorAll('[data-upsell-scroll]').forEach(sync);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
